/**
 * @file 维护前端路由列表
 * @author  fangsimin
 * @date    2019-01-02 11:12:42
 * @last Modified by    fangsimin
 * @last Modified time  2019-01-17 19:46:05
 */

const env = process.env;
export default new Proxy(
    {
        login: 'login',
        allReview: 'review/allreview', // 综合审核
        userReport: 'review/userreport', // 用户举报
        sndc: 'review/sndc', // 简单规则
        // home: 'user/home',
        setInfo: 'user',
        dashboard: 'dashboard',
        'applied-list': 'applied-list',
        'create-account': 'create-account',
        user: 'user', // 录入用户信息页面
        onboarding: 'onboarding', // 首页登录页面
        oldAccount: 'account', // 旧账户页面
        account: 'customer-relationship/account', // 账户审核页面
        agency: 'customer-relationship/agency',
        team: 'customer-relationship/team',
        'onboarding-result': 'onboarding-result', // 媒体审核列表页面
        report: 'report', // 电商数据平台
        logout: 'login/demo',
        home: 'home',
        overview: 'overview',
        inviteError: 'invite-error',
        solutions: 'solutions',
        cases: 'cases',
        'case-detail': 'case-detail',
        'about': 'about',
        'help-center': 'help-center',
        finance: 'finance',
        financeRecharge: 'finance/recharge',
        partner: 'partner',
        'account-analysis': 'account-analysis',
        'partner-detail': 'partner/details',
        'operation-log': 'operation-log',
        'creative': 'creative',
        'creative-external': 'creative-external',
        'creative-rejection': 'creative-rejection',
        'menu-settings': 'menu-settings',
        'uri-list': 'uri-list',
        'members': 'members',
        'role-settings': 'role-settings',
        'course': 'course',
        'course-details': 'course-details',
        'creative-upload': 'bulk-tools/creative'
    }, {

        /**
         * 代理每个api路径获取都加上BASE_URI
         * @param  {Object} target 原对象
         * @param  {string} name 要获取的键值
         * @return {string}
         */
        get: (target, name) => {
            return target[name]
                ? target[name] === 'home'
                    ? '/'
                    : [env['BASE_URI'], env['MODULE_CMP'], target[name]].join('/').replace(/\/\//g, '/')
                : '/';
        }
    }
);



// WEBPACK FOOTER //
// ./src/constants/path.js